(() => {
  const configNode = document.getElementById('IflLabMixCheckoutConfig');
  if (!configNode || customElements.get('ifl-lab-progress')) return;
  const config = JSON.parse(configNode.textContent), widgets = new Set();
  let cart = null, flight = null, timer, failed = false, revision = 0, dirty = false, fingerprint = null;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:cart?.currency || 'USD'}).format(cents/100);
  const measure = items => window.IFLLabMixState.measure(items,config.eligible);
  const refresh = () => {
    if (flight) { dirty = true; return flight; }
    const requestedRevision = revision;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);
    flight = fetch(`${config.root}cart.js`,{headers:{Accept:'application/json'},cache:'no-store',signal:controller.signal})
      .then(response => { if (!response.ok) throw new Error(); return response.json(); })
      .then(value => {
        if (requestedRevision !== revision) { dirty = true; return; }
        cart=value; failed=false; widgets.forEach(widget=>widget.render());
        const nextFingerprint = JSON.stringify([value.total_price,value.items.map(item=>[item.key,item.quantity,item.final_line_price,item.line_level_discount_allocations])]);
        if (nextFingerprint !== fingerprint) {
          fingerprint = nextFingerprint;
          if(typeof publish==='function' && typeof PUB_SUB_EVENTS!=='undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'ifl-lab-sync',cartData:value});
        }
      })
      .catch(()=>{failed=true;widgets.forEach(widget=>widget.render());})
      .finally(()=>{clearTimeout(timeout);flight=null;if(dirty){dirty=false;schedule();}});
    return flight;
  };
  const schedule = () => {clearTimeout(timer);timer=setTimeout(refresh,400);};
  class Progress extends HTMLElement {
    connectedCallback() {
      widgets.add(this);
      const json=this.querySelector('[data-lab-variants]');
      this.product=json ? JSON.parse(json.textContent) : null;
      this.scope=this.closest('product-info') || this.closest('section');
      if(this.product && this.product.variants.some(v=>config.eligible.includes(String(v.id)))){
        this.scope?.classList.add('ifl-lab-product');
        this.scope?.querySelectorAll('variant-selects option').forEach(option=>{if(/3\s*vials?/i.test(option.textContent)){option.hidden=true;option.disabled=true;}});
        const selectedId=this.scope?.querySelector('product-form input[name="id"]')?.value;
        const old=this.product.variants.find(v=>String(v.id)===String(selectedId));
        if(old && /3\s*vials?/i.test(old.title)){
          const strength=old.title.split(/·|\//)[0].trim();
          const singles=this.product.variants.filter(v=>config.eligible.includes(String(v.id)));
          const replacement=singles.find(v=>v.title.split(/·|\//)[0].trim()===strength)||singles[0];
          const url=new URL(location.href);url.searchParams.set('variant',replacement.id);location.replace(url.href);return;
        }
      }
      this.onChange=()=>this.render();
      if(this.product){this.scope?.addEventListener('change',this.onChange);this.scope?.addEventListener('input',this.onChange);}
      this.render();schedule();
    }
    disconnectedCallback(){widgets.delete(this);this.scope?.removeEventListener('change',this.onChange);this.scope?.removeEventListener('input',this.onChange);}
    render(){
      const current=this.querySelector('[data-lab-current]'),next=this.querySelector('[data-lab-next]'),estimate=this.querySelector('[data-lab-estimate]');
      if(!current)return;
      let variant=this.selected;
      if(this.product){
        const id=this.scope?.querySelector('product-form input[name="id"]')?.value;
        variant=this.product.variants.find(v=>String(v.id)===String(id));
        this.quantity=Number(this.scope?.querySelector('input[name="quantity"]')?.value)||1;
      }
      this.hidden=Boolean((this.product || this.selected) && (!variant || !config.eligible.includes(String(variant.id))));
      if(this.product)this.scope?.classList.toggle('ifl-lab-single',!this.hidden);
      if(!cart){current.textContent=failed?'Savings will update when your cart reconnects.':'Checking your current mix…';next.textContent='';estimate.textContent='';return;}
      const before=measure(cart.items);
      current.textContent=before.count ? `${before.count} eligible ${before.count===1?'vial':'vials'} · ${before.percent}% Lab Mix savings` : 'Mix More. Save More.';
      next.textContent=before.count>=6 ? 'Maximum savings unlocked · qualifies for complimentary 30 mL water.' : `Add ${before.count<2?2-before.count:1} ${before.count===0?'vials':'vial'} for ${before.count<2?5:before.percent+5}% off${before.count===3?' + complimentary 10 mL water':before.count===5?' + a complimentary upgrade to 30 mL water':''}.`;
      if(before.count===4)next.textContent+=' Qualifies for complimentary 10 mL water.';
      estimate.textContent='';
      if(variant?.available){
        const after=measure([...cart.items,{variant_id:variant.id,original_price:variant.price,quantity:Math.max(1,Math.min(99,this.quantity||1))}]);
        estimate.textContent=`Estimated after adding: ${after.percent}% off. Additional Lab Mix savings: ${money(after.savings-before.savings)}. Eligible merchandise subtotal ${after.subtotal>=before.subtotal?'increases':'decreases'} by ${money(Math.abs(after.subtotal-before.subtotal))}. Before tax and other discounts.`;
      }else if(!this.product && !this.selected){
        const savings=cart.items.reduce((sum,item)=>sum+(item.line_level_discount_allocations||[]).filter(a=>a.discount_application?.title?.startsWith('THE LAB MIX — ')&&a.discount_application.title.endsWith('% OFF')).reduce((n,a)=>n+a.amount,0),0);
        estimate.textContent=`Lab Mix savings applied: ${money(savings)}. Water does not count toward your mix.`;
      }
    }
  }
  customElements.define('ifl-lab-progress',Progress);
  document.addEventListener('ifl:cart-changed',()=>{revision++;schedule();});
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();});
  window.addEventListener('focus',schedule);window.addEventListener('pageshow',schedule);
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){
    subscribe(PUB_SUB_EVENTS.cartUpdate,schedule);
    subscribe(PUB_SUB_EVENTS.variantChange,()=>widgets.forEach(widget=>widget.render()));
  }
})();
